@if (visible()) {
  <app-global-popup (clickOutside)="accept()">
    <div role="alertdialog" aria-modal="true" aria-labelledby="session-expired-title"
      class="relative flex h-min max-h-[80dvh] w-[600px] max-w-[90dvw] flex-col gap-6 overflow-y-auto rounded-[19px] bg-default-background px-2.5 py-4">
      <div class="flex items-center gap-3">
        <i class="pi pi-exclamation-triangle text-warning-500" style="font-size: 24px" aria-hidden="true"></i>
        <h2 id="session-expired-title" class="text-sub-header text-default-theme">
          {{ tMsg('session_expired_title', 'Sesión Expirada') }}
        </h2>
      </div>
      <p class="text-body text-neutral-500">
        {{ tMsg('session_expired_message', 'Por favor, inicie sesión nuevamente.') }}
      </p>
      <div class="flex justify-end">
        <app-global-button onkeydown="" (click)="accept()" [label]="tBtn('button_accept', 'Aceptar')" />
      </div>
    </div>
  </app-global-popup>
}
